import { useEffect, useRef } from 'react';
export function useKeyBinding(props) {
    var bind = props.bind, onAction = props.onAction, disabled = props.disabled;
    var partialPropsRef = useRef({ onAction: onAction });
    partialPropsRef.current.onAction = onAction;
    useEffect(function () {
        var listener = function (event) {
            if (bind === event.code) {
                partialPropsRef.current.onAction(event);
            }
        };
        if (!disabled) {
            document.addEventListener('keyup', listener);
        }
        return function () {
            document.removeEventListener('keyup', listener);
        };
    }, [disabled, bind]);
}
